module.exports = __webpack_public_path__ + "static/media/17_BOJO_MEIA_TACA_LISO_03.8a30d45c.jpg";